import { render } from "./how_to_get_additional_images.vue?vue&type=template&id=15144b85"
import script from "./how_to_get_additional_images.vue?vue&type=script&lang=js"
export * from "./how_to_get_additional_images.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__